import { render } from "./LumpSumsAndTax.vue?vue&type=template&id=f4a5236a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__